'use strict';

var account = require('./../../../../app_storefront_core/cartridge/js/pages/account'),
	bonusProductsView = require('./../bonus-products-view'),
	quickview = require('./../quickview'),
	util = require('./../util'),
	forceInitRecomm = require('./recommendations'),
	cartStoreInventory = require('./../../../../app_storefront_core/cartridge/js/storeinventory/cart'),
	productTile = require('../product-tile'),
	orderDuties = require('./../util/order-duties'),
  util = require('./../util'),
  stickykit = require('./../stickykit'),
  stickykitOptions = {
    'container': '.b-cart-totals',
    'options': {
      'parent': '.b-content',
      'offset_top': function() {
        return $('.js-sticky_header-wrapper').height();
      },
      'bottoming': true,
    }
  };

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    if ($('.js-gift-wrapping').length) {
        $('input[name$="_isGiftWrap"]').val($('.js-gift-wrapping').prop('checked'));
    }

	$('#cart-table').on('click', '.js-order_product-edit_link', function (e) {
		e.preventDefault();
		quickview.show({
			url: $(this).data('href'),
			source: 'cart'
		});
	})
	.on('click', '.bonus-item-actions a, .bonusproducts a', function (e) {
		e.preventDefault();
		bonusProductsView.show(this.href);
	})
	.one('change', '.js-cart_quantity_field', function (e) {
		$('.js-cart-update').attr('disabled', true);
		setTimeout(function () {
			$('#cart-items-form').submit();
		}, 1500);
	});
	// override enter key for coupon code entry
	$('form input[name$="_couponCode"]').on('keydown', function (e) {
		if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

    $('.js-gift-wrapping').on('change', function(e){
        $('input[name$="_isGiftWrap"]').val($(this).prop('checked'));
    });

	//to prevent multiple submissions of the form when removing a product from the cart
	var removeItemEvent = false;
	$('button[name$="deleteProduct"]').on('click', function (e) {
		if (removeItemEvent) {
			e.preventDefault();
		} else {
			removeItemEvent = true;
		}
	});

	//validate coupon code
  var $couponInput = $('input[name$="_couponCode"]');
  var $error = $('form .js-coupon-error');
  var $addCouponButton = $('#add-coupon');

  // Validate coupon code function
  function validateCoupon() {
    const code = $couponInput.val().trim();

    if (code.length === 0) {
      $error.html(Resources.COUPON_CODE_MISSING);
      return false;
    }

    $error.empty();
    return true;
  }

  $couponInput.on('keyup', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();

      if (validateCoupon()) {
        $addCouponButton.trigger('click');
      }
    }
  });

  $addCouponButton.on('click', function (e) {
    if (!validateCoupon()) {
      e.preventDefault();
    }
  });

  //toggle coupon code
  var $couponCodeLink = $('.js-coupon_code-link');
  var $couponCodeItem = $('.js-coupon_code-item');
  var $couponCodeError = $('.js-coupon_code-item .error');

  if ($couponCodeLink.length && $couponCodeItem.length) {
    $couponCodeLink.on('click', function () {
      $couponCodeLink.toggleClass('active');
      $couponCodeItem.toggle();
    });
  }

  if ($couponCodeError.length && $couponCodeError.filter(':not(:empty)').length) {
    $couponCodeLink.trigger('click');
  }

  // Stick the upper checkout button
  if (util.isMobile()) {
    let headerHeight = $('.js-sticky_header-wrapper').height();
    $('.b-cart-actions.h-visible_phone').stick_in_parent({
      offset_top: headerHeight
    }).css({'z-index': 10});
  }
  
  // Update cart after a product has been added from a tile (i.e. from cart recommendations)
  $(window).on('before.additem.tocart', function() {
    if ($('#cart-items-form').length) {
      setTimeout(function () {
        $('#cart-items-form').submit();
      }, 1000);
    } else if ($('.b-cart-empty')){
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
  });
  
  //Init productTile for Predictive recommendations
  forceInitRecomm.init();
  document.addEventListener('recommendations.loaded', function() {
    productTile.init();
  });
  orderDuties.init();

  if (!util.isMobile()) {
    stickykit.init(stickykitOptions, true);
  }
}

exports.init = function () {
	initializeEvents();
	if (SitePreferences.STORE_PICKUP) {
		cartStoreInventory.init();
	}
	account.initCartLogin();
};
